// src/utils/nlp.js
import nlp from "compromise";

export const normalizeSpeechText = (text) => {
  return text
    .toLowerCase()
    .replace(/\bto\b|\btoo\b/g, " two ")
    .replace(/\bfor\b/g, " four ")
    .replace(/\bate\b/g, " eight ")
    .replace(/\bwon\b/g, " one ")
    .replace(/\bwangtg\b|\bwantg\b|\bwannt\b|\bwaant\b/g, " want ")
    .replace(/\s+/g, " ")
    .trim();
};

// Hinglish normalizer (roman hindi words -> english tokens)
export const normalizeHinglishWords = (text) => {
  return text
    // quantities
    .replace(/\b(ek)\b/g, " one ")
    .replace(/\b(do)\b/g, " two ")
    .replace(/\b(teen)\b/g, " three ")
    .replace(/\b(chaar|char)\b/g, " four ")
    .replace(/\b(paanch|panch)\b/g, " five ")
    .replace(/\b(chhe)\b/g, " six ")
    .replace(/\b(saat)\b/g, " seven ")
    .replace(/\b(aath)\b/g, " eight ")
    .replace(/\b(nau)\b/g, " nine ")
    .replace(/\b(das)\b/g, " ten ")

    // items
    .replace(/\b(dudh|doodh|dood)\b/g, " milk ")
    .replace(/\b(seb|sab)\b/g, " apple ")
    .replace(/\b(kela|kele|kelaa)\b/g, " banana ")
    .replace(/\b(santra|santara)\b/g, " orange ")

    // add/remove phrases
    .replace(/\b(jod do|jodo|jod|daal do|daalo|dalo|add karo|add kr|chahie)\b/g, " add ")
    .replace(/\b(hata do|hatao|hata|nikal do|nikalo|nikal|remove karo|delete karo|delete kr)\b/g, " remove ")

    .replace(/\s+/g, " ")
    .trim();
};

export const extractQuantity = (text) => {
  const doc = nlp(text);
  const nums = doc.numbers().toNumber().out("array");

  if (nums.length > 0) return parseInt(nums[0]);

  const digitMatch = text.match(/\d+/);
  if (digitMatch) return parseInt(digitMatch[0]);

  return 1;
};

export const cleanItemName = (text) => {
  return text
    .replace(
      /\b(i|me|my|we|us|our|add|buy|need|want|would|like|remove|delete|please|to|too|for|a|an|the|one|two|three|four|five|six|seven|eight|nine|ten|dozen)\b/g,
      ""
    )
    .replace(/\d+/g, "")
    .replace(/\s+/g, " ")
    .trim();
};

export const isAddIntent = (t) =>
  t.includes("add") || t.includes("buy") || t.includes("need") || t.includes("want");

export const isRemoveIntent = (t) =>
  t.includes("remove") || t.includes("delete");
